import React, { useState, useEffect } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Container,
  FormGroup,
  FormText,
  Form,
  Input,
  Label,
  Row,
  Col,
} from "reactstrap";
import { helper } from "lib/helper";
import Loader from "components/loader/Loader";
import statesModel from "models/states.model";
import Select from "react-select";

import { Country, State, City } from "country-state-city";
import { ICountry, IState, ICity } from "country-state-city";
const AddState = () => {
  const [addsLoadig, setAddsLoadig] = useState(false);
  const navigate = useNavigate();
  const [selectedState, setSelectedState] = useState(null);
  const [selectedisoCode, setSelectedStateIsoCode] = useState(null);
  const [states, setStates] = useState([]);
  const [selectedCity, setSelectedCity] = useState("");
  const [citiesOfSelectedState, setCitiesOfSelectedState] = useState([]);

  console.log(selectedCity, "selectedCity");

  useEffect(() => {
    // Fetching states on component mount
    const statesData = State.getStatesOfCountry("IN"); // Fetching Indian states
    // Mapping state data to react-select format
    const statesOptions = statesData.map((state) => ({
      label: state.name,
      value: state.name,
      isoCode: state.isoCode,
    }));
    setStates(statesOptions);
  }, []);

  const handleStateChange = (selectedOption) => {
    setSelectedState(selectedOption.value);
    setSelectedStateIsoCode(selectedOption.isoCode);
    // Fetching cities of selected state
    const citiesData = City.getCitiesOfState("IN", selectedOption.isoCode);
    console.log("citiesData", citiesData); // Check if cities are fetched correctly
    const citiesOptions = citiesData.map((city) => ({
      label: city.name,
      value: city.name,
    }));
    console.log("citiesOptions:", citiesOptions); // Check if city options are created correctly
    setCitiesOfSelectedState(citiesOptions);
    setSelectedCity(""); // Reset selected city when state changes
  };





  const handleSubmitState = (event) => {
    setAddsLoadig(true);
    event.preventDefault();
    const form = new FormData(event.target);
    form.append("name", `${selectedState} ${selectedisoCode}`);
    // You can adjust the header configuration according to your API requirements
    statesModel
      .createState(form)
      .then((response) => {
     
        helper.sweetalert.toast("Your state add.", "success");
        navigate("/admin/state");
        setAddsLoadig(false);
      })
      .catch((error) => {
        setAddsLoadig(false);
        helper.sweetalert.toast(error?.response?.data?.name[0], "error");
      });
  };


  return (
    <>
      <Container className="pt-7">
        <Row>
          <div className="col">
            <Card className="shadow">
              <CardHeader className="border-0 d-flex justify-content-between ">
                <h3 className="mb-0">Add State</h3>
              </CardHeader>

              <CardBody>
                <div>
                  <Form onSubmit={handleSubmitState}>
                  

                  <Row>
                        <Col md={6}>
                          <FormGroup>
                            <Label for="stateSelect">State</Label>
                            <Select
                              id="stateSelect"
                              // name="stateSelect"
                              value={{
                                label: selectedState,
                                value: selectedState,
                                isoCode: selectedState,
                              }}
                              onChange={handleStateChange}
                              options={states}
                              placeholder="Select State"
                              isSearchable={true} // Enable searching within dropdown
                            />
                          </FormGroup>
                        </Col>
                      </Row>
                    {/* <Row>
                <Col md={6}>
                  <FormGroup>
                    <Label for="exampleEmail">Added Date</Label>
                    <Input id="contact" name="contact" type="number" />
                  </FormGroup>
                </Col>

                <Col md={6}>
                  <FormGroup>
                    <Label for="exampleEmail">Status</Label>
                    <Input id="status" name="status" type="select">
                      <option value="">Activate</option>
                      <option value="option1">Deactivate</option>
                      <option value="option2">Pending</option>
                    </Input>
                  </FormGroup>
                </Col>
              </Row> */}

                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <Button color="secondary" to="/admin/state" tag={Link}>
                        Cancel
                      </Button>

                      {addsLoadig ? (
                        <Loader color={"blue"} />
                      ) : (
                        <Button
                        
                          type="submit"
                          style={{ float: "right", marginLeft: "5%" ,backgroundColor:"#080278",color:"white",border:"none"}}
                        >
                          Save
                        </Button>
                      )}
                    </div>
                  </Form>
                </div>
              </CardBody>
            </Card>
          </div>
        </Row>
      </Container>
    </>
  );
};

export default AddState;
